import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const cn = (...inputs) => twMerge(clsx(inputs));

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-[var(--calendar-padding,0.75rem)] bg-card text-foreground', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        month_caption: 'flex justify-center pt-1 relative items-center text-sm font-semibold mb-2',
        nav: 'flex items-center space-x-1 absolute right-3 top-3 z-10',
        button_previous: cn(
          'h-7 w-7 bg-transparent p-0 opacity-55 hover:opacity-100 transition-opacity border border-border rounded-md flex items-center justify-center text-foreground hover:bg-accent cursor-pointer'
        ),
        button_next: cn(
          'h-7 w-7 bg-transparent p-0 opacity-55 hover:opacity-100 transition-opacity border border-border rounded-md flex items-center justify-center text-foreground hover:bg-accent cursor-pointer'
        ),
        month_grid: 'w-full border-collapse space-y-1',
        weekdays: 'flex',
        weekday: 'text-muted-foreground rounded-md w-[var(--calendar-day-size,2.25rem)] font-normal text-[0.8rem] text-center flex justify-center items-center',
        week: 'flex w-full mt-2',
        day: 'h-[var(--calendar-day-size,2.25rem)] w-[var(--calendar-day-size,2.25rem)] text-center text-sm p-0 relative focus-within:relative focus-within:z-20 flex justify-center items-center',
        day_button: cn(
          'h-[var(--calendar-day-size,2.25rem)] w-[var(--calendar-day-size,2.25rem)] p-0 font-normal rounded-md hover:bg-accent hover:text-accent-foreground flex items-center justify-center cursor-pointer transition-colors text-foreground aria-selected:bg-primary aria-selected:text-primary-foreground aria-selected:hover:bg-primary aria-selected:hover:text-primary-foreground focus:outline-none'
        ),
        selected: 'bg-primary text-primary-foreground rounded-md',
        today: 'bg-accent/40 text-accent-foreground font-semibold border border-accent',
        outside: 'text-muted-foreground opacity-30',
        disabled: 'text-muted-foreground opacity-20 cursor-not-allowed pointer-events-none',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, className, ...props }) => {
          if (orientation === 'left') {
            return <ChevronLeft className={cn("h-4 w-4", className)} {...props} />;
          }
          return <ChevronRight className={cn("h-4 w-4", className)} {...props} />;
        },
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
